import { ApiClientCredential, ClientCredentials } from '@era/settings-sdk';
import { createActionGroup, props, emptyProps } from '@ngrx/store';
import { ErrorModel } from '@era/app';

// ============================================================================
// API ACTIONS (Group - using createActionGroup)
// ============================================================================

export const ApiClientSettingApiActions = createActionGroup({
  source: 'API Client setting API',
  events: {
    'Settings loaded': props<{ settings: ApiClientCredential[] }>(),
    'Settings loaded error': props<{ error: ErrorModel }>(),
    'Setting added': props<{ setting: ApiClientCredential }>(),
    'Setting added error': props<{ setting: ApiClientCredential; error: ErrorModel }>(),
    'Setting updated': props<{ setting: ApiClientCredential }>(),
    'Setting updated error': props<{ setting: ApiClientCredential; error: ErrorModel }>(),
    'Setting deleted': props<{ setting: ApiClientCredential }>(),
    'Setting deleted error': props<{ setting: ApiClientCredential; error: ErrorModel }>(),
  },
});

// ============================================================================
// VIEW ACTIONS (Group - using createActionGroup)
// ============================================================================

export const ApiClientSettingViewActions = createActionGroup({
  source: 'API Client setting view',
  events: {
    'Setting added': props<{ setting: ApiClientCredential }>(),
    'Setting updated': props<{ originalSetting: ApiClientCredential; setting: ClientCredentials }>(),
    'Setting deleted': props<{ setting: ApiClientCredential }>(),
  },
});

// ============================================================================
// RESOLVER ACTIONS (Group - using createActionGroup)
// ============================================================================

export const ApiClientSettingResolverActions = createActionGroup({
  source: 'API Client setting resolver',
  events: {
    'Setting requested': emptyProps(),
  },
});
